import React from 'react';
import PropTypes from 'prop-types';
import SidebarDetailStyles from './SidebarDetail.styled';
import { useInView } from 'react-intersection-observer';

const SidebarDetail = ({
  title = null,
  description = null,
  children,
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <SidebarDetailStyles
      ref={ref}
      className={`block-sidebar_detail ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      {title && <h3>{title}</h3>}
      {description && (
        <div className='descWrapper'>
          <p className='type-caption'>{description}</p>
        </div>
      )}
      {children && <div>{children}</div>}
    </SidebarDetailStyles>
  );
};

SidebarDetail.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAnimated: PropTypes.bool,
};

export default SidebarDetail;
